<template>
	<div id="app">
		<router-view class="view"></router-view>
	</div>
</template>

<script>
	import Vue from 'vue'
	export default {
		name: 'app',
		components: {},
		mounted() {
			Vue.prototype.$serviceProviderId=undefined
			if (localStorage.getItem('serviceProviderId')) {
				Vue.prototype.$serviceProviderId = localStorage.getItem('serviceProviderId')
			}
		}
	}
</script>

<style lang="scss">
	@import "../src/assets/css/common.scss";

	html,
	body {
		height: 100%;
		width: 100%;
	}

	* {
		padding: 0;
		margin: 0;
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		// font-family: serif;// cursive
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		width: 100%;
		height: 100%;
	}
</style>